export default __webpack_public_path__ + "static/media/1_hotelverse.e2b704ad.svg";